import { gtmDataLayerPush } from '../../gtm'
import { type CartIntermediateEntryObject } from '../model/CartIntermediateContextValue'

export const gtmDataLayerPushCartIntermediateAddToCart = ({
  entry,
  prescriptionType,
  quantity,
}: {
  entry: CartIntermediateEntryObject
  prescriptionType: string
  quantity: number
}): void => {
  const { id: offerId, product } = entry

  if (!product) {
    return
  }

  const productId = 'id' in product ? product.id : product.upid
  gtmDataLayerPush({
    cartAction: 'add',
    event: 'addToCart_PDP',
    eventType: 'conversion',
    offer: offerId,
    prescriptionType,
    product,
    quantity,
    upid: productId,
  })
}
